var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.557524 1.01736C1.02615 0.548737 1.78596 0.548737 2.25458 1.01736L6.20606 4.9688L10.1576 1.01738C10.6262 0.548754 11.3859 0.548754 11.8546 1.01738C12.3232 1.486 12.3232 2.24581 11.8546 2.71444L7.90319 6.66592L11.8546 10.6174C12.3232 11.0861 12.3232 11.8458 11.8546 12.3144C11.3859 12.7831 10.6262 12.7831 10.1576 12.3144L6.20606 8.36304L2.2546 12.3144C1.78596 12.7831 1.02616 12.7831 0.557539 12.3144C0.0888977 11.8458 0.0888977 11.0861 0.557539 10.6174L4.50894 6.66592L0.557524 2.71442C0.0888984 2.2458 0.0888984 1.48599 0.557524 1.01736Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.780c8054a89bfed9211ee635b3759200.svg";
export { ForwardRef as ReactComponent };